import { apiSlice } from "../../../_api/apiSlice";

export const organisationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOrganisationInfo: builder.mutation({
      query: (id) => ({
        url: `/organisation/info/${id}`,
        method: "GET",
      }),
    }),
    // Public logo/name/powered-by for customer-facing pages (no login). The
    // full /organisation/info/:id is gated to the org's own users.
    getOrganisationBranding: builder.mutation({
      query: (id) => ({
        url: `/organisation/branding/${id}`,
        method: "GET",
      }),
    }),
    createOrganisation: builder.mutation({
      query: (data) => ({
        url: `/organisation`,
        method: "POST",
        body: data,
      }),
    }),
    updateOrganisation: builder.mutation({
      query: (data) => ({
        url: `/organisation`,
        method: "PATCH",
        body: data,
      }),
    }),
    updateOrganisationARR: builder.mutation({
      query: (data) => ({
        url: `/organisation/arr`,
        method: "PATCH",
        body: data,
      }),
    }),
    updateOrganisationIsOnboarded: builder.mutation({
      query: (data) => ({
        url: `/organisation/onboarded`,
        method: "PATCH",
        body: data,
      }),
    }),
    // Go-live checks for the Finish setup page (a payment gateway with a webhook secret is
    // mandatory). The server also syncs the matching setup task, so `setupChanged` means the
    // cached org needs a refresh.
    getOrganisationReadiness: builder.query({
      query: () => ({
        url: `/organisation/readiness`,
        method: "GET",
      }),
    }),
    updateOrganisationSetupItemTaskCompletion: builder.mutation({
      query: (data) => ({
        url: `/organisation/taskCompletion`,
        method: "PATCH",
        body: data,
      }),
    }),
    updateOrgLogo: builder.mutation({
      query: (data) => ({
        url: "uploads/organisationProfileImage",
        method: "POST",
        body: data,
      }),
    }),
    verifyEmailOfOrganisation: builder.mutation({
      query: (data) => ({
        url: `user/verifyEmail?email=${data.email}`,
        method: "GET",
      }),
    }),
    deleteOrgLogo: builder.mutation({
      query: () => ({
        url: "uploads/organisationProfileImage",
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetOrganisationInfoMutation,
  useGetOrganisationBrandingMutation,
  useCreateOrganisationMutation,
  useUpdateOrganisationMutation,
  useUpdateOrganisationARRMutation,
  useUpdateOrganisationIsOnboardedMutation,
  useVerifyEmailOfOrganisationMutation,
  useGetOrganisationReadinessQuery,
  useUpdateOrganisationSetupItemTaskCompletionMutation,
  useDeleteOrgLogoMutation,
  useUpdateOrgLogoMutation
} = organisationApiSlice;
